import React from 'react';
import PropTypes from 'prop-types';
import ResultsTile from '../tile';
import { Product } from '../../../../components/common/structured-data';
import { CTA } from '../../../../components';
import styles from './results-tiles.module.scss';

export const OtherTiles = ({ otherTiles }) => {
	const { heading, dynamic } = otherTiles;
	const tiles = dynamic[0].manual_entries;

	return (
		<div className='mb-10 mt-5'>
			<h2 className='text-subtitle-2'>{heading}</h2>
			<div className={styles.tileGrid}>
				{tiles?.map((tile, index) => {
					const { backend_name, static_url } = tile;
					return (
						<ResultsTile
							key={`${index}-${backend_name}`}
							tile={tile}
							pdpURL={static_url}
							btnColor='primary-alt'
							hideCompare
						/>
					);
				})}
			</div>
		</div>
	);
};

OtherTiles.propTypes = {
	otherTiles: PropTypes.object,
};

export const ResultsTiles = ({ currentTiles, staticTiles, dynamicPageState, pageUrl }) => {
	const tileCheckArr = ['part', 'screen', 'sash'];

	const returnPdpUrl = (tileData) => {
		const { backend_name, static_url } = tileData;
		if (backend_name && staticTiles.find((currentTile) => backend_name.toLowerCase() === currentTile.backend_name?.toLowerCase())?.static_url) {
			return staticTiles.find((currentTile) => backend_name.toLowerCase() === currentTile.backend_name.toLowerCase()).static_url;
		} else if (backend_name && staticTiles.find((currentTile) => backend_name.toLowerCase().includes(currentTile.backend_name?.toLowerCase()))?.static_url) {
			return staticTiles.find((currentTile) => backend_name.toLowerCase().includes(currentTile.backend_name.toLowerCase())).static_url;
		} else {
			return static_url;
		}
	};

	return (
		<div className={styles.tileGrid}>
			{currentTiles?.map((tile, index) => {
				if (tile.type === 'pro' || tile.type === 'quiz') {
					if ((tile.type === 'quiz' && !pageUrl.includes('windows')) || pageUrl.includes('windows/parts')) {
						return null;
					}
					return (
						<div
							key={index}
							id='inline-promo-tile'
							className='grid grid-cols-1 border border-neutral-200 bg-center px-4 py-6'
							style={{
								backgroundImage: `url(${tile.image.url})`,
							}}
						>
							<div className='sm:col-start-1 sm:row-start-1 sm:self-center'>
								<p className='text-subtitle font-bold text-black'>{tile.heading}</p>
								<p className='text-body-2 mt-3 text-black'>{tile.description}</p>
							</div>
							<CTA
								data={tile.cta[0]}
								className='mt-6 !w-full sm:col-start-1 sm:row-start-1 sm:self-end'
							/>
						</div>
					);
				}

				if (!tileCheckArr.includes(tile.type)) {
					return (
						<ResultsTile
							key={`${index}-${tile.backend_name}`}
							tile={tile}
							pdpURL={returnPdpUrl(tile)}
							dynamicPageState={dynamicPageState}
							type={tile.type}
							btnColor='primary'
							hideCompare
						/>
					);
				} else {
					return (
						<ResultsTile
							key={`${index}-${tile.backend_name}`}
							tile={tile}
							pdpURL={`/shop/parts/configure/?id=${tile.backend_name}&type=${tile.type}${tile.type === 'screen' || tile.type === 'sash' ? `&brand=${tile.header}` : ''}&heading=${tile.display_name}&options=`}
							dynamicPageState={dynamicPageState}
							type={tile.type}
							btnColor='primary'
							hideCompare
						/>
					);
				}
			})}

			{currentTiles?.map((tile, index) => {
				if (!tile || tile.bundle || !returnPdpUrl(tile) || !tile?.price?.consumer?.amount || tile?.price?.consumer?.amount === 0) return null;

				return (
					<Product
						product={tile}
						productUrl={returnPdpUrl(tile)}
						images={tile.manual_image?.url ? tile.manual_image.url : tile.image_url}
						name={tile.header + ' ' + tile.display_name}
						description={tile.material}
						key={index}
					/>
				);
			})}
		</div>
	);
};

ResultsTiles.propTypes = {
	currentTiles: PropTypes.array,
	staticTiles: PropTypes.array,
	highlightItems: PropTypes.array,
	dynamicPageState: PropTypes.bool,
	priceHeading: PropTypes.array,
	startingAt: PropTypes.string,
	quickShipItems: PropTypes.array,
	pageUrl: PropTypes.string,
};
